import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { retry, catchError } from 'rxjs/operators';
import { map } from 'rxjs/operators';
import { LocalStorage } from 'ngx-store';

//Model
import { IncidentMobile } from '../model/incident.model';
import { Ticket } from '../model/ticket.model';
import { Url } from '../model/users.model';
import { Incident } from '../model/incident.model';

@Injectable()
export class IncidentsService {
  @LocalStorage() url: Url;
  private headers = new Headers({ 'Content-Type': 'application/json' });
  
    // Http Headers
  httpOptions = {
    headers: new HttpHeaders({
      'Content-Type': 'application/json'
    })
  }
    constructor(public http:HttpClient) { }

    getTickets(filter = '', start = '', end = ''): Observable<Ticket[]> { 
      if (filter) {
        filter = '/' + filter; 
        if (filter == '/range' && start != '' && end != '')
        // if (start == end){
        //   filter = '/range'
        // }
        // else{
          filter = '/range/' + start + '/' + end; 
        // }
      } else filter = '';
      console.log("TICKET SERVICE",this.url.rest,'/tms/getTickets',filter)
		return this.http.get<Ticket[]>(this.url.rest  + '/tms/getTickets'+filter, this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }

        getTicketsByDriverId(id:number, filter = '', start = '', end = ''): Observable<Ticket[]> { 
      if (filter) {
        filter = '/' + filter; 
        if (filter == '/range' && start != '' && end != '')
        // if (start == end){
        //   filter = '/range'
        // }
        // else{
          filter = '/range/' + start + '/' + end; 
        // }
      } else filter = '';
      console.log('/tms/getTicketsByDriverId/', id,filter)
      return this.http.get<Ticket[]>(this.url.rest  + '/tms/getTicketsByDriverId/' + id +filter, this.httpOptions)
          .pipe(
            retry(1),
            catchError(this.handleError)
          ) 
      }
  
    getIncidentsByDriverId(id:number, filter = '', start = '', end = ''): Observable<Incident[]> { 
      if (filter) {
        filter = '/' + filter; 
        if (filter == '/range' && start != '' && end != '')
        // if (start == end){
        //   filter = '/range'
        // }
        // else{
          filter = '/range/' + start + '/' + end; 
        // }
      } else filter = '';
		  return this.http.get<Incident[]>(this.url.rest  + '/tms/getIncidentsByDriverId/' + id + filter, this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }


    
      getIncidents(filter = '', start = '', end = ''): Observable<Incident[]> { 
        if (filter) {
          filter = '/' + filter; 
          if (filter == '/range' && start != '' && end != '')
          // if (start == end){
          //   filter = '/range'
          // }
          // else{
            filter = '/range/' + start + '/' + end; 
          // }
        } else filter = '';
        return this.http.get<Incident[]>(this.url.rest  + '/tms/getIncidents'+filter, this.httpOptions)
          .pipe(
            retry(1),
            catchError(this.handleError)
          ) 
      }
  
  

    getIncidentPageData() {
      return this.http.get(this.url.rest  + '/tms/getIncidentPageData', this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }
    
    getIncidentPageDataMisc() {
      return this.http.get(this.url.rest  + '/tms/getIncidentPageDataMisc', this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }

    getFleet() {
      return this.http.get(this.url.rest  + '/tms/getFleet', this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }

    createTicket(ticket:Ticket): Observable<Ticket> {	
      return this.http.post<Ticket>(this.url.rest  + '/tms/createTicket', ticket , this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }

    updateTicket(ticket: Ticket): Observable<Ticket> {
      return this.http.post<Ticket>(this.url.rest  + '/tms/updateTicket', ticket , this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }

    deleteTicket(id: number) {
      return this.http.delete(this.url.rest  + '/tms/deleteTicket/' + id);
    }   

    createIncident(incident:Incident): Observable<Incident> {	
      return this.http.post<Incident>(this.url.rest  + '/tms/createIncident', incident , this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }
    createIncidentMobile(incident:IncidentMobile): Observable<IncidentMobile> {	
      return this.http.post<IncidentMobile>(this.url.rest  + '/api/sendIncident', incident , this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }

    updateIncident(incident:Incident): Observable<Incident> {
      return this.http.post<Incident>(this.url.rest  + '/tms/updateIncident', incident, this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    }

    deleteIncident(id: number) {
      return this.http.delete(this.url.rest  + '/tms/deleteIncident/' + id);
    }  

    getTicketStatuses(): Observable<any[]> { 
    return this.http.get<any[]>(this.url.rest  + '/tms/getTicketStatuses', this.httpOptions)
        .pipe(
          retry(1),
          catchError(this.handleError)
        ) 
    } 
   

  // Error handling
  handleError(error) {
    let errorMessage = '';
    if (error.error instanceof ErrorEvent) {
      // Get client-side error
      errorMessage = error.error.message;
    } else {
      // Get server-side error
      errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
    }
    console.log(errorMessage);
    return throwError(errorMessage);
  }
}